export const SHOW_CUSTOMIZEDMESSAGE = 'SHOW_CUSTOMIZEDMESSAGE';
export const HIDE_CUSTOMIZEDMESSAGE = 'HIDE_CUSTOMIZEDMESSAGE';
export const UPDATE_CUSTOMIZEDMESSAGE_DATA='UPDATE_CUSTOMIZEDMESSAGE_DATA'
export const showCustomizedMessage = ()=>(dispatch) => { 
    dispatch({
        type: SHOW_CUSTOMIZEDMESSAGE,
        payload: {showMessage: true}
      });
};
export const hideCustomizedMessage = () => ({
    type: HIDE_CUSTOMIZEDMESSAGE,
    payload: {
        showMessage:false
    }
})
export const updateCustomizedMessage = (message,icon,color,textcolor) => ({
    type: UPDATE_CUSTOMIZEDMESSAGE_DATA,
    payload: {
        message:message,
        icon:icon,
        color:color,
        textcolor:textcolor
    }
})


